var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import colors from '../colors';
import { cssVarsThemed } from '../cssUtils';
var lightnessOpacityLevels = {
    light: { base: 0.02, offset: 0.04 },
    medium: { base: 0.06, offset: 0.06 },
};
var darkModeElevationColorMap = {
    0: '#171717',
    1: '#181818',
    2: '#191919',
    3: '#191919',
    4: '#1C1C1C',
    6: '#1F1F1F',
    8: '#212121',
    12: '#242424',
    16: '#262626',
    24: '#292929',
};
/**
 * Sets `background-color` and `box-shadow` based on the elevation level
 */
export var elevationCss = function (level, options) {
    var lightness = (options === null || options === void 0 ? void 0 : options.lightness) || 'medium';
    var _a = lightnessOpacityLevels[lightness], base = _a.base, offset = _a.offset;
    var bgCss = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n\n    background-color: var(--backgroundElevated);\n  "], ["\n    ", "\n\n    background-color: var(--backgroundElevated);\n  "])), cssVarsThemed({
        backgroundElevated: {
            light: colors.salt100,
            dark: darkModeElevationColorMap[level],
        },
    }));
    if (level === 0) {
        return bgCss;
    }
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    box-shadow: 0 0 ", "px 0 rgba(0, 0, 0, ", "),\n      0 ", "px ", "px 0 rgba(0, 0, 0, ", ");\n  "], ["\n    ", "\n    box-shadow: 0 0 ", "px 0 rgba(0, 0, 0, ", "),\n      0 ", "px ", "px 0 rgba(0, 0, 0, ", ");\n  "])), bgCss, level, base, level, level, offset);
};
/**
 * @deprecated Use `elevationCss` instead.
 */
var Elevation = styled.div.withConfig({
    shouldForwardProp: function (prop) { return !['level', 'lightness'].includes(prop); },
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (_a) {
    var level = _a.level, _b = _a.lightness, lightness = _b === void 0 ? 'medium' : _b;
    return elevationCss(level, { lightness: lightness });
});
export default Elevation;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Elevation.js.map